// extracted by mini-css-extract-plugin
export default {"productCarousel":"p1-z"};